export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6149.d3485494.jpg";